  export const formatTimeHM = (time?: string): string => {
    if (!time) return ''
    const parts = time.split(':')
    return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : time
  }